import * as Sentry from '@sentry/nextjs'
import { getConfig } from '~/config/config'
import { CreateSubmissionInput, CreateSubmissionOutput } from '~/shared/api-generated-types'

const { publicRuntimeConfig } = getConfig()

export async function createSubmission(input: CreateSubmissionInput): Promise<CreateSubmissionOutput> {
  try {
    const mutationBody = {
      query: `
        mutation createSubmission($input: CreateSubmissionInput!) {
          createSubmission(input: $input) {
            __typename success
          }
        }
        `,
      variables: {
        input,
      },
    }
    const response = await fetch(publicRuntimeConfig.api, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'apollographql-client-name': 'lobby',
        'apollographql-client-version': publicRuntimeConfig.environment, // TODO: get git sha?
      },
      body: JSON.stringify(mutationBody),
    })
    const parsedResponse = await response.json()
    if (parsedResponse.errors) throw new Error(JSON.stringify(parsedResponse.errors))
    return parsedResponse
  } catch (err) {
    // Log this error to sentry but dont panic.
    console.error('Failed to submit feedback', err)
    Sentry.captureException(err)
    return { __typename: 'CreateSubmissionOutput', success: false }
  }
}
